module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d290a2f6958b222711fb4d56966c3978.png";